module.exports = __webpack_public_path__ + "static/media/transportindustry.890001ab.jpg";